export default __webpack_public_path__ + "static/media/escritorio.6afa33fd.png";